// eslint-disable-next-line import/no-extraneous-dependencies, simple-import-sort/imports
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import useResizeObserver from '@react-hook/resize-observer';
import { ModuleRegistry,
// RowHeightParams,
// RowClickedEvent,
// RowDataUpdatedEvent,
// RowDoubleClickedEvent,
// SelectionChangedEvent,
// SortChangedEvent,
 } from '@ag-grid-community/core';
import { AgGridReact } from '@ag-grid-community/react';
import { ChangeDetectionStrategyType } from '@ag-grid-community/react/lib/shared/changeDetectionService';
import cx from 'classnames';
import { debounce } from 'lodash';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Key } from 'w3c-keys';
import { LoadingIndicator } from '../../loading-indicator';
// import { disableClickGridCells } from '../table-utils';
// import { AvatarDataProps } from './cell/avatar-cell/avatar-cell';
import { CELL_TYPE_COMPONENTS } from '../table-list-view/cell/cell-type-service';
// import { HoverActionDataProps } from './cell/hover-action-cell/hover-action-cell';
// import { MenuDataProps } from './cell/menu-cell/menu-cell';
// import { SortState } from './header/header-cell/sortable-header-cell';
// import {
//     addCommonCells,
//     DEFAULT_COL_DEF,
// } from './header/header-definition-service/header-definition-service';
import cssVars from './object-table-scss-to-js-vars.module.scss';
import styles from './object-table.module.scss';
import './object-table-override.scss';
import * as objectTableUtil from './object-table.util';
import { OBJECT_TABLE_COLUMN } from './column/object-table-column';
import { ObjectTableColumnKey } from './column-util/object-table-column-util';
ModuleRegistry.registerModules([ClientSideRowModelModule]);
export const ObjectTable = ({ data, columns, onRowsSelected, selectedRowsIds = [], isRowSelectable, 
// options: {
//     // onRowsSelected,
//     // selectedRowsIds = [],
//     // isRowSelectable,
//     // suppressMovable = false,
//     // suppressRowClickSelection = true,
//     // checkboxHeaderClass = '',
// },
// rowMenu,
hideRowCheckbox, 
// rowActionItems,
// onFavouriteClickHandler,
// onAvatarClick,
// onSortingChanged,
// onRowClickHandler,
// onRowCommandClickHandler,
loading, agGridContext, 
// onRowDoubleClickHandler,
disableClickCells = [], immutableData = true, headerHeight, rowHeight, rowSelection = 'multiple', isRowClickable, refreshAfterOnClick = false, setAgGridApi, hideLoader = false, hasAutoHeightColumns = false, onGridReadyCallback, isRowDisabled, ...restProps }) => {
    const [gridApi, setGridApi] = useState(null);
    const [colDefs, setColDefs] = useState(objectTableUtil.getColDefs(columns));
    useEffect(() => {
        setColDefs(objectTableUtil.getColDefs(columns));
    }, [columns]);
    // On resizing the object table and if the column are locked then for non-fixed column to resize.
    const [offsetWidth, setOffsetWidth] = useState(0);
    const contentRef = useRef(null);
    // Debounced sizeColumnsToFit to prevent flickering horizontal scrollbar during resize
    const debouncedSizeColumnsToFit = useCallback(debounce(() => {
        if (gridApi) {
            // Use requestAnimationFrame to ensure DOM updates are complete
            requestAnimationFrame(() => {
                gridApi.sizeColumnsToFit();
            });
        }
    }, 200), [gridApi]);
    // Cleanup debounced function on unmount
    useEffect(() => {
        return () => {
            debouncedSizeColumnsToFit.cancel();
        };
    }, [debouncedSizeColumnsToFit]);
    useResizeObserver(contentRef, () => {
        var _a;
        const contentOffsetWidth = (_a = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth;
        // Only trigger resize if width difference is significant to prevent flickering
        const widthDifference = Math.abs(contentOffsetWidth - offsetWidth);
        if (contentOffsetWidth && widthDifference > 5) {
            setOffsetWidth(contentOffsetWidth);
            debouncedSizeColumnsToFit();
        }
    });
    // const allDisableClickGridCells = [
    //     ...disableClickGridCells,
    //     ...disableClickCells,
    // ];
    // const onRowClickedWrapper = (event: RowClickedEvent) => {
    //     if (!isRowClickable || isRowClickable(event.data)) {
    //         const cellId:
    //             | string
    //             | undefined = gridApi?.getFocusedCell()?.column?.getColId();
    //         if (!cellId || !allDisableClickGridCells.includes(cellId)) {
    //             const mouseEvent = event.event as MouseEvent;
    //             if (
    //                 (mouseEvent?.ctrlKey || mouseEvent?.metaKey) &&
    //                 onRowCommandClickHandler
    //             ) {
    //                 onRowCommandClickHandler(event.data);
    //             } else if (onRowClickHandler) {
    //                 onRowClickHandler(event.data);
    //             }
    //         }
    //     }
    // };
    const onCellKeyDown = useCallback((e) => {
        var _a, _b, _c, _d, _e;
        if (!e.event) {
            return;
        }
        const keyboardEvent = e.event;
        const key = keyboardEvent.key;
        if (key === Key.Enter) {
            // if (!isRowClickable || isRowClickable(e.data)) {
            //     const cellId:
            //         | string
            //         | undefined = gridApi
            //         ?.getFocusedCell()
            //         ?.column?.getColId();
            //     if (!cellId || !allDisableClickGridCells.includes(cellId)) {
            //         // const mouseEvent = event.event as MouseEvent;
            //         if (onRowCommandClickHandler) {
            //             onRowCommandClickHandler(e.data);
            //         } else if (onRowClickHandler) {
            //             onRowClickHandler(e.data);
            //         }
            //     }
            // }
            switch (e.column.colId) {
                case ObjectTableColumnKey.PrimaryName:
                    (_a = e.value) === null || _a === void 0 ? void 0 : _a.primaryTextOnClick();
                    break;
                case ObjectTableColumnKey.Favorite:
                    (_b = e.value) === null || _b === void 0 ? void 0 : _b.onClick(e, e.data);
                    break;
                case ObjectTableColumnKey.Author:
                    (_c = e.value) === null || _c === void 0 ? void 0 : _c.handler(e.value);
                    break;
                case ObjectTableColumnKey.RowAction: {
                    // Find and click the action menu button using data-testid
                    // This allows the ActionMenuColumn button to open the menu
                    const actionMenuButton = e.event.target.querySelector('[data-testid="action-menu-button"]');
                    if (actionMenuButton) {
                        actionMenuButton.click();
                    }
                    else if ((_d = e.value) === null || _d === void 0 ? void 0 : _d.actions) {
                        // Fallback for ActionColumn (direct action links without menu)
                        // Only execute the first action instead of all actions
                        const firstActionGroup = e.value.actions[0];
                        if ((_e = firstActionGroup === null || firstActionGroup === void 0 ? void 0 : firstActionGroup.items) === null || _e === void 0 ? void 0 : _e[0]) {
                            firstActionGroup.items[0].onClick(firstActionGroup.items[0]);
                        }
                    }
                    break;
                }
                default:
                    break;
            }
        }
    }, []);
    // const onRowDoubleClickedWrapper = (event: RowDoubleClickedEvent) => {
    //     if (onRowDoubleClickHandler) {
    //         const cellId:
    //             | string
    //             | undefined = gridApi?.getFocusedCell()?.column?.getColId();
    //         if (!cellId || !disableClickCells.includes(cellId)) {
    //             onRowDoubleClickHandler(event.data);
    //         }
    //     }
    // };
    const getRowId = (params) => params.data.id;
    const onGridReady = async (event) => {
        await setGridApi(event.api);
        if (setAgGridApi) {
            setAgGridApi(event.api);
        }
        event.api.sizeColumnsToFit();
        if (loading && !hideLoader) {
            event.api.showLoadingOverlay();
        }
        if (onGridReadyCallback) {
            onGridReadyCallback();
        }
    };
    const preSelectRows = (api) => {
        if (!selectedRowsIds.length) {
            return false;
        }
        let areRowsSelected = false;
        data.forEach(({ id }) => {
            const currentNode = api.getRowNode(id);
            if (selectedRowsIds.indexOf(id) !== -1) {
                currentNode.setSelected(true);
                areRowsSelected = true;
            }
            else {
                currentNode.setSelected(false);
            }
        });
        return areRowsSelected;
    };
    useEffect(() => {
        if (!gridApi) {
            return;
        }
        if (loading) {
            gridApi.showLoadingOverlay();
        }
        else {
            gridApi.hideOverlay();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, data]);
    useEffect(() => {
        if (!gridApi) {
            return;
        }
        if (!selectedRowsIds.length) {
            gridApi.deselectAll();
            return;
        }
        const areRowsSelected = preSelectRows(gridApi);
        if (!areRowsSelected) {
            gridApi.deselectAll();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gridApi, selectedRowsIds]);
    const loadingOverlayParams = {
        hideLoader,
    };
    const noRowsOverlayComponent = hideLoader ? '' : 'customLoadingOverlay';
    const frameworkComponent = {
        customLoadingOverlay: () => (React.createElement(LoadingIndicator.Global, { className: styles.loadingContainer, "data-testid": "object-table-global-loader" },
            React.createElement("div", null))),
        ...CELL_TYPE_COMPONENTS,
        ...OBJECT_TABLE_COLUMN,
    };
    // const onSortChanged = (e: SortChangedEvent) => {
    //     const sortStateModel = e.columnApi
    //         .getColumnState()
    //         .find(({ sort }) => !!sort);
    //     if (onSortingChanged && sortStateModel)
    //         onSortingChanged([sortStateModel]);
    // };
    const onSelectionChanged = (e) => {
        const selectedIds = e.api
            .getSelectedNodes()
            .map((node) => node.id)
            .filter((element) => element !== undefined);
        if (onRowsSelected)
            onRowsSelected(selectedIds);
    };
    // const onRowDataUpdated = (e: RowDataUpdatedEvent) => {
    //     const areRowsSelected = preSelectRows(e.api);
    //     if (!areRowsSelected) {
    //         if (onRowsSelected) onRowsSelected([]);
    //     }
    // };
    const getRowHeight = () => {
        return rowHeight || 72;
    };
    // The getRowHeight is needed only when there is no auto height column for the object table.
    const rowHeightProps = {};
    if (!hasAutoHeightColumns) {
        rowHeightProps.getRowHeight = getRowHeight;
    }
    const context = {
        // rowMenu,
        hideRowCheckbox,
        // rowActionItems,
        // onFavouriteClickHandler,
        // onAvatarClick,
        ...agGridContext,
    };
    // const getRowClass = isRowClickable
    //     ? (params: any) => {
    //           return isRowClickable(params.data)
    //               ? undefined
    //               : styles.rowNotClickable;
    //       }
    //     : undefined;
    const getRowClass = (params) => {
        if (isRowDisabled) {
            return isRowDisabled(params.data) ? styles.rowDisabled : '';
        }
        return styles.rowNotClickable;
    };
    // const onFirstDataRendered = (params: any) => {
    //     // Assuming you want to get the height of the cell in the first row and first column
    //     // const a = this.gridApi;
    //     const firstCellElement2 = params.api.getCellRendererInstances();
    //     const firstCellElement21 = params.api.getDisplayedRowAtIndex(0);
    //     const firstCellElement = params.api
    //         .getCellRendererInstances()[0][0]
    //         .getGui();
    //     const cellHeight = firstCellElement.clientHeight;
    //     console.warn(
    //         'Height of the first cell:',
    //         cellHeight,
    //         firstCellElement2,
    //         firstCellElement21,
    //     );
    // };
    return (React.createElement("div", { ref: contentRef, className: cx(styles.objectTableContainer, {
            [styles.clickableRows]: true, // onRowClickHandler,
        }) },
        React.createElement(AgGridReact
        // defaultColDef={DEFAULT_COL_DEF}
        // onFirstDataRendered={onFirstDataRendered}
        , { 
            // defaultColDef={DEFAULT_COL_DEF}
            // onFirstDataRendered={onFirstDataRendered}
            columnDefs: colDefs, context: context, components: frameworkComponent, rowData: data, modules: [ClientSideRowModelModule], suppressRowClickSelection: true, rowSelection: rowSelection, suppressNoRowsOverlay: hideLoader, rowClass: "object-table-row-container", headerHeight: headerHeight !== null && headerHeight !== void 0 ? headerHeight : Number(cssVars.metadatalistrowheight), rowHeight: 72, 
            // onRowClicked={(event: RowClickedEvent) => {
            //     onRowClickedWrapper(event);
            //     if (refreshAfterOnClick) {
            //         gridApi?.refreshCells();
            //     }
            // }}
            onCellKeyDown: onCellKeyDown, getRowId: getRowId, onGridReady: onGridReady, loadingOverlayComponent: noRowsOverlayComponent, loadingOverlayComponentParams: loadingOverlayParams, 
            // using similar overlay for no rows, assuming components
            // will handle an empty ([]) state outside this component
            noRowsOverlayComponent: noRowsOverlayComponent, noRowsOverlayComponentParams: loadingOverlayParams, 
            // onSortChanged={onSortChanged}
            // onRowDataUpdated={onRowDataUpdated}
            onSelectionChanged: onSelectionChanged, 
            // onRowDoubleClicked={onRowDoubleClickedWrapper}
            domLayout: "autoHeight", 
            // onRowDataChanged={onRowDataUpdated}
            rowDataChangeDetectionStrategy: ChangeDetectionStrategyType.DeepValueCheck, suppressLoadingOverlay: hideLoader, immutableData: immutableData, isRowSelectable: isRowSelectable, getRowClass: getRowClass, ...rowHeightProps, ...restProps })));
};
//# sourceMappingURL=object-table.js.map